import type { CSSProperties } from "react";
import { LegalPage, LegalSection } from "../components/LegalPage";

const listStyle: CSSProperties = { margin: 0, paddingLeft: 22, display: "flex", flexDirection: "column", gap: 8 };

export default function Terminos() {
  return (
    <LegalPage title="Términos de Uso" updated="Junio 2026">
      <LegalSection title="¿Quiénes somos?">
        <p style={{ margin: 0 }}>
          PzicoDosis es una plataforma digital de psicología fundada en México, dedicada a acercar
          herramientas de salud mental a toda LATAM. Al usar la plataforma aceptas estos términos.
        </p>
        <p style={{ margin: "12px 0 0" }}>
          Contacto: <a href="mailto:psicodosis2024@gmail.com" style={{ color: "#C49A8A" }}>psicodosis2024@gmail.com</a>
        </p>
      </LegalSection>

      <LegalSection title="Uso aceptable de la plataforma">
        <p style={{ margin: "0 0 12px" }}>
          PzicoDosis es un espacio de acompañamiento y psicoeducación, no un servicio de emergencia ni
          un sustituto de atención psicológica o psiquiátrica profesional. Al usar la comunidad y el foro
          te comprometes a:
        </p>
        <ul style={listStyle}>
          <li>Tratar a los demás miembros con respeto y empatía</li>
          <li>No publicar contenido ofensivo, discriminatorio o que incite al daño propio o ajeno</li>
          <li>No usar la plataforma con fines comerciales, fraudulentos o de spam</li>
          <li>Brindar información veraz al crear tu cuenta</li>
        </ul>
        <p style={{ margin: "12px 0 0" }}>
          Si estás en una situación de crisis, busca ayuda profesional o de emergencia inmediata; la
          comunidad de PzicoDosis no reemplaza ese tipo de atención.
        </p>
      </LegalSection>

      <LegalSection title="Propiedad intelectual del contenido">
        <p style={{ margin: 0 }}>
          Las guías, materiales de apoyo, textos y demás contenido publicado por PzicoDosis son
          propiedad de PzicoDosis y se ofrecen para tu uso personal y no comercial. No está permitido
          reproducir, redistribuir o vender este contenido sin autorización previa. El contenido que tú
          publiques en el foro sigue siendo tuyo, pero nos das permiso para mostrarlo dentro de la
          plataforma.
        </p>
      </LegalSection>

      <LegalSection title="Limitación de responsabilidad">
        <p style={{ margin: 0 }}>
          PzicoDosis ofrece contenido psicoeducativo y un espacio de comunidad, pero no garantiza
          resultados específicos sobre tu bienestar. No nos hacemos responsables por decisiones tomadas
          a partir del contenido de la plataforma ni por interacciones entre usuarios dentro de la
          comunidad. El servicio se ofrece "tal cual" y puede sufrir interrupciones o cambios.
        </p>
      </LegalSection>

      <LegalSection title="Ley aplicable">
        <p style={{ margin: 0 }}>
          Estos términos se rigen por las leyes de México. Cualquier controversia relacionada con el uso
          de la plataforma se resolverá ante los tribunales competentes de México.
        </p>
      </LegalSection>

      <LegalSection title="Cambios a estos términos">
        <p style={{ margin: 0 }}>
          Notificaremos cualquier cambio importante por email.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
